import { gql } from '@apollo/client';

export const GENERATE_PICKUP_TASK_DOWNLOAD_REPORT = gql`
    query GeneratePickupTaskDownloadReport(
        $filter: PickupTaskFilterInput
        $timezone: String
    ) {
        generatePickupTaskDownloadReport(
            filter: $filter
            timezone: $timezone
        )
    }
`;

export interface GeneratePickupTaskReportResponse {
    generatePickupTaskDownloadReport?: string;
}
